import { Card, CardHeader } from '@mui/material';
import { DateTimeFormats } from '@src/app/enums';
import { DateRange } from '@src/app/store';
import { dateFormatter, percentageFormatter } from '@src/app/utils/GenericUtils';
import { MultiPortfolioPerformanceDetails } from 'clientportalshared';

interface Props {
  dateRange: DateRange;
  data: MultiPortfolioPerformanceDetails;
}

export const TotalReturnCard = ({ dateRange, data }: Props): JSX.Element => {
  return (
    <Card
      elevation={0}
      sx={{
        paddingTop: '20px',
        paddingRight: '16px',
        paddingLeft: '16px',
        paddingBottom: '20px',
        borderRadius: '24px',
        borderWidth: '1px',
        border: '1px solid #E9E9E9',
        display: 'flex',
        flexDirection: 'column',
        minHeight: '100%',
      }}
    >
      <CardHeader
        title={`Total Return from ${dateFormatter(dateRange.dateFrom, false, DateTimeFormats.DateOnly)} to ${dateFormatter(
          dateRange.dateTo,
          false,
          DateTimeFormats.DateOnly
        )}`}
        subheader={percentageFormatter(data.totalReturnPercentage ?? 0, 2)}
        titleTypographyProps={{
          fontSize: 16,
          color: '#222222',
        }}
        subheaderTypographyProps={{
          fontWeight: 700,
          fontSize: 20,
          color: '#222222',
        }}
      />
    </Card>
  );
};
